<template>
  <full-screen :title="t('wrong-time.title')" :show-close="false">
    <div class="w-full h-full flex items-center justify-center relative">
      <div
        class="max-w-4xl flex flex-col gap-2 items-center justify-center text-n-0 text-center px-4"
      >
        <img src="@/assets/device-error.svg" class="w-44 h-44" />
        <div class="heading-2">
          {{ t('block-version.native-app.title') }}
        </div>
        <div class="font-text text-base">
          {{ t('block-version.native-app.description') }}
        </div>
      </div>
    </div>
    <template #footer>
      <l-button class="w-48" size="medium" @click="goToUpdate">
        {{ t('block-version.update') }}
      </l-button>
    </template>
  </full-screen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { onBeforeRouteLeave } from 'vue-router'

import { LButton } from '@last/core-ui/paprika'

import FullScreen from '@/components/FullScreen.vue'
import { getDeviceInfo } from '@/utils/device'

const { t } = useI18n()

async function goToUpdate() {
  const deviceInfo = await getDeviceInfo()
  if (deviceInfo.platform === 'ios') {
    window.open('https://apps.apple.com/es/app/last-app/id1481474529', '_blank')
  } else if (deviceInfo.platform === 'android') {
    window.open('https://play.google.com/store/apps/details?id=app.last.pos', '_blank')
  }
}

onBeforeRouteLeave(() => false)
</script>
